var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",style:(_vm.inputBG)},[_c('div',{staticClass:"image"},[_c('img',{staticClass:"pic",style:(_vm.picStyle),attrs:{"src":_vm.src}})]),_c('div',{staticClass:"desc",style:(_vm.descStyle)},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }